import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import transformDataForMoodChart from '../utility/transformDataForMoodChart'
import MoodChart from './MoodChart'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import ObjectActions from '../redux/objectRedux'
import { makeGetData } from '../selectors/dataSelector'

class MopraMoodChartContainer extends PureComponent {
  handleClick = objects => {
    const { actions } = this.props
    actions.objectsSelected(objects)
  }

  handleSelect = objects => {
    const { actions } = this.props
    actions.objectsSelected(objects)
  }

  handleDeselect = objects => {
    const { actions } = this.props
    actions.objectsDeselected(objects)
  }

  render () {
    const { data } = this.props
    const transformedData = transformDataForMoodChart(data)

    return (
      <MoodChart
        data={transformedData}
        handleClick={this.handleClick}
        handleSelect={this.handleSelect}
        handleDeselect={this.handleDeselect}
      />
    )
  }
}

const makeMapStateToProps = () => {
  const getDatetime = makeGetDatetime()
  const getData = makeGetData()

  const mapStateToProps = (state, ownPropsp) => {
    return {
      data: getData(
        state,
        'Mopra',
        getFeaturesFromGeoJson,
        datum => datum.timestamp === getDatetime(state, 'Mopra')
      ),
      datetime: getDatetime(state, 'Mopra')
    }
  }

  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      objectsSelected: objects =>
        dispatch(ObjectActions.objectsSelected(objects)),
      objectsDeselected: objects =>
        dispatch(ObjectActions.objectsDeselected(objects))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(
  MopraMoodChartContainer
)



// WEBPACK FOOTER //
// ./src/charts/MopraMoodChartContainer.js